import { Box, Button, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { usePostHog } from 'posthog-js/react';

import ShareButton from '@/pages/Markets/MarketsComponents/Share/ShareButton';
import { Market } from '@/slices/marketsSlice';

export const MarketComingSoon = ({ market }: { market: Market }) => {
  const postHog = usePostHog();
  return (
    <Box
      sx={{
        position: 'relative',
        mt: 3
      }}
    >
      <Box sx={{ overflow: 'hidden', maxHeight: 'calc(100vh - 120px)' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',

            gap: 1,

            flex: 1,
            mb: 1
          }}
        >
          <Typography
            sx={{ mr: 4 }}
            variant='h2'
          >
            {market?.metadata?.displayName}
          </Typography>
          <Box sx={{ ml: 'auto' }}>
            <ShareButton
              additionalTitle={market?.pages[0]?.name}
              title={market?.metadata?.displayName}
            />
          </Box>
        </Box>
        <img
          alt='Market placeholder'
          src='/market-placeholder.png'
          style={{
            width: '100%',
            maxHeight: '100%',
            objectFit: 'cover',
            objectPosition: 'top'
          }}
        />
      </Box>
      <Box
        sx={{
          position: 'absolute',
          left: '-24px',
          top: 0,
          right: '-24px',
          bottom: 0,
          zIndex: 1,
          background: 'rgba(18, 22, 63, 0.10)',
          backdropFilter: 'blur(4px)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          gap: 2,
          flex: 1
        }}
      >
        <Typography>Market page coming soon</Typography>
        <Button
          sx={{ width: 320 }}
          variant='contained'
          onClick={() => {
            postHog?.capture('gxgo_register_market_interest', {
              $current_url: market?.metadata?.displayName
            });
            enqueueSnackbar("Thank you for your interest. We'll keep you posted!", {
              variant: 'success',
              autoHideDuration: 5000
            });
          }}
        >
          Register interest
        </Button>
      </Box>
    </Box>
  );
};
